package com.evoapps.evoshift.ui

import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor

// --- Metallic Color Palette (SH-196: the base's and the accent's of the appearance on show) ---
/** Lighter base for gradients (a lighter navy in the default look). */
val ReflectiveBlue: Color get() = AppAppearance.palette.base.reflective
/** Slightly distinct base for cards. */
val CardBlue: Color get() = AppAppearance.palette.base.card

/** The metallic accent (a darker gold in the default look). */
val DarkGold: Color get() = AppAppearance.palette.accent.metallic
/** The bright accent highlight. */
val LightGold: Color get() = AppAppearance.palette.accent.bright

// --- Shared Brushes ---

private val GoldBrushes = PerAppearance { p -> Brush.linearGradient(colors = listOf(p.accent.metallic, p.accent.bright, p.accent.metallic)) }
private val DarkBackgroundBrushes = PerAppearance { p -> Brush.linearGradient(colors = listOf(p.base.base, p.base.reflective, p.base.base)) }
private val CardBrushes = PerAppearance { p -> Brush.linearGradient(colors = listOf(p.base.card, p.base.cardHighlight, p.base.card)) }

val GoldMetallicBrush: Brush get() = GoldBrushes.current

val DarkMetallicBackgroundBrush: Brush get() = DarkBackgroundBrushes.current

val CardMetallicBrush: Brush get() = CardBrushes.current

/** SH-230: the light panels and cards are plain white now (the cream gradient looked washed out). */
val LightMetallicBrush: Brush = SolidColor(CardSurface)
